import React from 'react';

import { useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';

import CardHeader from '../../containers/CardHeader';
import CardSectionTitle from '../../containers/CardSectionTitle';

import { Card, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import pathAPICall from '../../app/apiCalls/pathAPICall';
import { path_details } from "../../app/apiEndpoints"

const PathsDetails = (props) => {
    let { pathType } = useParams();

    const [path, setPath] = useState({})
    const pathID = useSelector((state) => state.currentPathID)
    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)
    const canEdit = isSysadmin

    useMemo(() => {
        const getPath = async () => {
            if(pathID > 0) {
                const data = await pathAPICall(path_details, {'pathID': pathID, 'pathType': pathType, 'requester': userID, 'company': companyID })
                setPath(data.path)
            }
        }
        getPath()
    }, [pathID, pathType, userID, companyID])


    if(!path) return <></>

    return (
        <>
        <Card className='mt-5'>
            <CardHeader title={path.path} />
            <Card.Body>
                <Accordion>
                    {canEdit && path.type === '4' &&
                    <Card>
                        <CardSectionTitle title="CPC Admin" />
                        <Card.Body>
                            <p><strong>Default CPC:</strong> ${path.default_cpc}</p>
                            <Link to={`/paths/${pathType}/cpc/${path.pathid}/`} title="Management">CPC Management</Link>
                        </Card.Body>
                    </Card>
                    }
                    {canEdit && path.type === '2' &&
                    <Card>
                        <CardSectionTitle title="Path Admin" />
                        <Card.Body>
                            <p><strong>Active Path?:</strong> {path.is_active === '1' ? 'Yes' : 'No'}</p>
                            <p><strong>In Cascade?:</strong> {path.useInAutoFlow === '1' ? 'Yes' : 'No'}</p>
                            {path.age_min > 0 && <p><strong>Age Minimum:</strong> {path.age_min}</p>}
                            {path.age_max > 0 && <p><strong>Age Maximum:</strong> {path.age_max}</p>}
                            <Link to={`/paths/${pathType}/edit/${path.pathid}/`} title="Management">Path Management</Link>
                        </Card.Body>
                    </Card>
                    }
                </Accordion>
            </Card.Body>
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(PathsDetails)